import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Props from './StepActionComponent';
import SubmitStepButton from './SubmitStepButton';
import Translation from "../../../../shared/Translation";
import WithCurrencyConfig from '../../../config/WithCurrencyConfig';
import { getJSFormattedCurrency } from '@h/currency';

const escapeValidators = [
  () => document.activeElement.name === "date_question",
  () => document.activeElement.className.startsWith("rdp")
]

const canUseEscapeKey = () => {
  if (escapeValidators.some(fn => fn())) {
    return false;
  }
  return true;
}

class StepAction extends Component<Props> {

    constructor(props){
        super(props);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event){
        if(event.key === "Escape" && canUseEscapeKey()){
            this.props.onBack();
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }
    getFormattedTotal = amount => {
      return this.props.currencyConfig ? getJSFormattedCurrency(this.props.orderTotal, this.props.currencyConfig) : '';
    }
    render() {
        return(
            <div>
                <footer className="checkout-form__footer">
                    <div className="checkout-form__buttons">
                      {!this.props.terminalId && <SubmitStepButton disabled={this.props.disabled} />}
                    </div>
                </footer>
            </div>
        )
    }
}
StepAction.propTypes = {
    firstStep: PropTypes.bool.isRequired,
    lastStep: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    orderTotal: PropTypes.number.isRequired,
    onBack: PropTypes.func.isRequired,
    terminalId: PropTypes.any,
};

export default (WithCurrencyConfig(StepAction))
